import charteredService from '@/api/chartered'
import { CHARTERED } from '../types'
import errorhandler from '@/utils/errorhandler.js'

export default {
  namespaced: true,
  state: {
    charteredBuses: [],
    charteredBusesName: [],
    sites: [],
    charteredBusGroupedBySite: [],
    charteredBusSiteId: null,
    devicesIds: [],
    blockAccessUponPriorCharteredBusBooking: false
  },
  getters: {
    charteredBuses: (state) => {
      return state.charteredBuses
    },
    charteredBusesName: (state) => {
      return state.charteredBusesName
    },
    charteredBusGroupedBySite: (state) => {
      return state.charteredBusGroupedBySite
    },
    charteredBusSiteId: (state) => {
      return state.charteredBusSiteId
    }
  },
  mutations: {
    [CHARTERED.CHARTERED_SET](state, charteredBuses) {
      state.charteredBuses = charteredBuses
    },
    [CHARTERED.AVAILABLE_CHARTERED_BUSES_SET](state, charteredBusesName) {
      state.charteredBusesName = charteredBusesName
    },
    [CHARTERED.SET_SITE](state, sites) {
      state.sites = sites
    },
    [CHARTERED.SET_CHARTEREDS_GROUPED_BY_SITE](state, charteredBusGroupedBySite) {
      state.charteredBusGroupedBySite = charteredBusGroupedBySite
    },
    [CHARTERED.SET_SITE_ID](state, charteredBusSiteId) {
      state.charteredBusSiteId = charteredBusSiteId
    },
    [CHARTERED.SET_CHARTERED_DEVICES] (state, devicesIds) {
      state.devicesIds = devicesIds
    },
    [CHARTERED.SET_CHARTERED_DEVICES_BLOCK_ACCESS] (state, blockAccessUponPriorCharteredBusBooking) {
      state.blockAccessUponPriorCharteredBusBooking = blockAccessUponPriorCharteredBusBooking
    }
  },
  actions: {
    setCharteredBusSiteId ({commit}, charteredBusSiteId) {
      commit(CHARTERED.SET_SITE_ID, charteredBusSiteId)
    },
    async getCharteredBuses({ commit, dispatch }) {
      try {
        let response = await charteredService.getCharteredBuses()
        commit(CHARTERED.CHARTERED_SET, response.data)
      }
      catch (error) {
        dispatch('Global/hideLoading', null, { root: true })
        return Promise.reject(error)
      }
    },
    async getAvailableCharteredBuses({ commit, dispatch }) {
      dispatch('Global/showLoading', null, { root: true })
      try {
        let response = await charteredService.getAvailableCharteredBuses()
        commit(CHARTERED.AVAILABLE_CHARTERED_BUSES_SET, response.data)
      }
      finally {
        dispatch('Global/hideLoading', null, { root: true })
      }
    },
    async addCharteredBuses({ dispatch }, charteredBus) {
      try {
        await charteredService.addCharteredBus(charteredBus)
        await dispatch('getCharteredBuses')
      }
      catch (error) {
        dispatch('Global/hideLoading', null, { root: true })
        return Promise.reject(error)
      }
    },
    async editCharteredBuses({ dispatch }, charteredBus) {
      try {
        await charteredService.editCharteredBus(charteredBus)
        await dispatch('getCharteredBuses')
      }
      catch (error) {
        dispatch('Global/hideLoading', null, { root: true })
        return Promise.reject(error)
      }
    },
    async getSitesWithChartereds ({commit, dispatch}) {
      try {
        let response = await charteredService.getSitesWithChartereds()
        commit(CHARTERED.SET_SITE, response.data)
      }
      catch (error) {
        dispatch('Global/hideLoading', null, {root: true})
        return Promise.reject(error)
      }
    },
    async getActiveCharteredBusesGroupedBySite ({commit, dispatch}) {
      try {
        let response = await charteredService.getActiveCharteredBusesGroupedBySite()
        commit(CHARTERED.SET_CHARTEREDS_GROUPED_BY_SITE, response.data)
      }
      catch (error) {
        dispatch('Global/hideLoading', null, {root: true})
        return Promise.reject(error)
      }
    },
    async activateChartered({dispatch}, chartered) {
      try {
        await charteredService.activateChartered(chartered)
        dispatch('Global/showMessage', 'saveSucessful', {root: true})
      } catch (error) {
        errorhandler.handleError(error);
        throw error
      }
    },
    async deactivateChartered({ dispatch }, payload) {
      try {
        dispatch('Global/showLoading', null, {root: true})
        await charteredService.deactivateChartered(payload.chartered, payload.cancelFutureBookings)
        dispatch('Global/showMessage', 'saveSucessful', { root: true })
      } catch (error) {
        errorhandler.handleError(error);
        throw error
      } finally {
        dispatch('Global/hideLoading', null, {root: true})
      }
    },
    async getCharteredBusDevices ({commit, dispatch}, charteredBusId) {
      try {
        dispatch('Global/showLoading', null, {root: true})
        let response = await charteredService.getCharteredBusDevices(charteredBusId)
        commit(CHARTERED.SET_CHARTERED_DEVICES, response.data.devices ?? [])
        commit(CHARTERED.SET_CHARTERED_DEVICES_BLOCK_ACCESS, response.data.blockAccessUponPriorBooking)
      } catch(error) {
        dispatch('Global/hideLoading', null, {root: true})
        return Promise.reject(error)
      } finally {
        dispatch('Global/hideLoading', null, {root: true})
      }
    },
    async saveCharteredDevices ({dispatch}, payload) {
      try {
        dispatch('Global/showLoading', null, {root: true})
        await charteredService.saveCharteredDevices(payload.workPlaceId, payload.devicesIds, payload.blockAccessUponPriorBooking)
        dispatch('Global/showMessage', 'saveSucessful', {root: true})
      } catch(error) {
        dispatch('Global/hideLoading', null, {root: true})
        return Promise.reject(error)
      } finally {
        dispatch('Global/hideLoading', null, {root: true})
      }
    },
  }
}
